<template>
  <!-- #region 마커 그룹화 간격 변경 -->
  <div style="flex: 1; width: 370px; height: 100%;">
    <MarkerGroup style="width: 100%; height: 100%;"/>
  </div>
  <!-- #endregion -->
  
  <div style="display: flex; flex-direction: column; gap: 20px; width: 370px; height: 100%;">
    <!-- #region 그룹 기본 사진 변경 -->
    <!-- <div class="modal-body-content" style="height: 276px; max-height: 276px;">
      <div class="modal-body-list-box" style="gap: 12px;">
        <div class="search-box-in-title" style="padding-right: 24px; margin-top: 20px;">
          <h2 :title="$t('change_group_default_image')" style="padding-left: 4px;">{{ $t('change_group_default_image') }}</h2>
        </div>
        <div class="marker-image" :style="getIsMobile() ? {padding: '0 24px'} : {}">
          <img :src="markerImage" alt="마커 이미지" />
          <ImageUploadPreview style="width: 180px; height: 100px;"/>
        </div>
        <div class="button-group" style="margin-top: 10px;" :style="getIsMobile() ? {height: '30px'} : {}">
          <button @click="deleteGroupNowIcon()" class="cancel-button" :disabled="!Get_Setting_Image('group_now_icon') && !previewImage">{{ $t('cancel') }}</button>
          <button @click="uploadGroupDefaultIcon()" class="action-button" :disabled="!previewImage">{{ $t('save') }}</button>
        </div>
      </div>
    </div> -->
    <!-- #endregion -->

    <!-- #region 배터리 상태 범위 설정 -->
    <div class="modal-body-content" style="height: 260px; max-height: 260px;">
      <div class="modal-body-list-box">
        <div class="search-box-in-title" style="padding-right: 24px; margin-top: 20px;">
          <h2 :title="$t('set_battery_status_range')" style="padding-left: 4px;">{{ $t('set_battery_status_range') }}</h2>
          <div class="button-group" style="width: 106px;">
            <button @click="saveBatteryLevelRange()" class="action-button">{{ $t('save') }}</button>
          </div>
        </div>
        <div class="progress-bar">
          <div :style="{ width: `${bRange1}%`, background: '#ddd' }"><img src="@/assets/images/battery3.svg" /><h3 style="text-align: center;">0 ~ {{ batteryA }}</h3></div>
          <div :style="{ width: `${bRange2}%`, background: '#fff' }"><img src="@/assets/images/battery2.svg" /><h3 style="text-align: center; top: -28px; bottom: 0;">{{ batteryA }} ~ {{ batteryB }}</h3></div>
          <div :style="{ width: `${bRange3}%`, background: '#ddd' }"><img src="@/assets/images/battery1.svg" /><h3 style="text-align: center;">{{ batteryB }} ~ 100</h3></div>
        </div>
        <div style="display: flex; align-items: center; gap: 10px; width: calc(100% - 48px);">
          <input type="number" v-model.number="batteryA" min="0" max="100" @blur="validateBatteryInput" />
          ~
          <input type="number" v-model.number="batteryB" min="0" max="100" @blur="validateBatteryInput" />
        </div>
      </div>
    </div>
    <!-- #endregion -->

    <!-- #region 신호 상태 범위 설정 -->
    <div class="modal-body-content" style="height: 260px; max-height: 260px;">
      <div class="modal-body-list-box">
        <div class="search-box-in-title" style="padding-right: 24px; margin-top: 20px;">
          <h2 :title="$t('set_signal_status_range')" style="padding-left: 4px;">{{ $t('set_signal_status_range') }}</h2>
          <div class="button-group" style="width: 106px;">
            <button @click="saveCellPowerRange()" class="action-button">{{ $t('save') }}</button>
          </div>
        </div>
        <div class="progress-bar">
          <div :style="{ width: `${cRange1}%`, background: '#ddd' }"><img src="@/assets/images/cell-power3.svg" /><h3 style="text-align: center;">-200 ~ {{ cellpowerA }}</h3></div>
          <div :style="{ width: `${cRange2}%`, background: '#fff' }"><img src="@/assets/images/cell-power2.svg" /><h3 style="text-align: center; top: -28px; bottom: 0;">{{ cellpowerA }} ~ {{ cellpowerB }}</h3></div>
          <div :style="{ width: `${cRange3}%`, background: '#ddd' }"><img src="@/assets/images/cell-power1.svg" /><h3 style="text-align: center;">{{ cellpowerB }} ~ 0</h3></div>
        </div>
        <div style="display: flex; align-items: center; gap: 10px; width: calc(100% - 48px);">
          <input type="number" v-model.number="cellpowerA" min="-200" max="0" @blur="validateCellPowerInput" />
          ~
          <input type="number" v-model.number="cellpowerB" min="-200" max="0" @blur="validateCellPowerInput" />
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>

  <div style="display: flex; flex-direction: column; gap: 20px; width: 370px; height: 100%;">
    <!-- #region 장치 상태 색상 설정 -->
    <div class="modal-body-content" style="height: 340px;">
      <div class="modal-body-list-box">
        <div class="search-box-in-title" style="padding-right: 24px; margin-top: 20px;">
          <h2 :title="$t('set_device_status_color')" style="padding-left: 4px;">{{ $t('set_device_status_color') }}</h2>
          <img src="@/assets/images/plus.svg" @click="addStateColorSetting()" style="cursor: pointer;"/>
        </div>
        <table style="min-width: 350px; height: calc(100% - 150px); padding: 0 24px;">
          <thead style="position: sticky; top: 0; z-index: 1; width: 100%;">
            <tr style="width: 100%;">
              <th class="w40p" style="cursor: default;">시간 (초)</th>
              <th class="w40p" style="cursor: default;">색상</th>
              <th class="w20p" style="cursor: default;">삭제</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(setting, index) in loadColorSettings" :key="index" style="width: 100%;">
              <td class="w40p">
                <input
                  type="number"
                  v-model.number="setting.time"
                  :readonly="index === loadColorSettings.length - 1"
                  :disabled="index === loadColorSettings.length - 1"
                  @blur="validateTime(index)"
                  @keydown.enter.prevent="validateTime(index)"
                />
              </td>
              <td class="w40p">
                <input
                  type="color"
                  v-model="setting.color"
                  style="height: 100%; border: none;"
                />
              </td>
              <td class="w20p" style="text-align: center; padding: 0;">
                <img v-if="index !== loadColorSettings.length - 1" @click.stop="removeStateColorSetting(index)" src="@/assets/images/delete.svg" :title="'삭제'"/>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="button-group" style="margin-bottom: 20px;" :style="getIsMobile() ? { width:'100%', padding:'0 24px' } : {}">
          <button @click="resetStateColorSettings()" class="cancel-button">{{ $t('cancel') }}</button>
          <button @click="saveStateColorSetting()" class="action-button">{{ $t('save') }}</button>
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>
</template>
  
<script setup>
import { computed, nextTick, onMounted, ref } from 'vue';
import { addStateColorSetting, loadColorSettings, removeStateColorSetting, resetStateColorSettings, saveStateColorSetting, validateTime } from '@/utils/ColorUtility';
// import { previewImage, previewImageFile } from '@/utils/ImageUtility';
// import ImageUploadPreview from '@/components/ImageUploadPreview.vue';
import MarkerGroup from '@/components/MarkerGroup.vue';
// import { Delete_Setting, Get_All_Settings_FromServer, Get_Setting, Get_Setting_Image, Modify_Setting, Set_Setting_Image } from '@/utils/Setting';
import { Get_Setting, Modify_Setting } from '@/utils/Setting';
import { getIsMobile } from '@/utils/GlobalUtility';

//#region 마커 사진 변경
// // 마커 이미지 경로
// const markerImage = computed(() => {
//   if (Get_Setting_Image('group_now_icon')) return Get_Setting_Image('group_now_icon');
//   else return Get_Setting_Image('group_default_icon');
// });

// // 파일 선택 시 이미지 업로드 처리
// const uploadGroupDefaultIcon = async () => {
//   if (previewImageFile.value) {
//     const method = Get_Setting_Image('group_now_icon') ? "PUT" : "POST"
//     await Set_Setting_Image('group_now_icon', "{}", previewImageFile.value, method);
//     await Get_All_Settings_FromServer();
//   }
// };

// const deleteGroupNowIcon = async () => {
//   if (Get_Setting_Image('group_now_icon')) {
//     await Delete_Setting('group_now_icon');
//     await Get_All_Settings_FromServer();
//   }
//   previewImage.value = null;
// }
//#endregion

//#region 배터리 상태 범위 설정
const batteryA = ref(Get_Setting('battery_level_range').low);
const batteryB = ref(Get_Setting('battery_level_range').high);
const validateBatteryInput = () => {
  if (batteryA.value < 0) batteryA.value = 0;
  if (batteryA.value > 100) batteryA.value = 100;
  if (batteryB.value < 0) batteryB.value = 0;
  if (batteryB.value > 100) batteryB.value = 100;
  if (batteryA.value > batteryB.value) batteryA.value = batteryB.value - 1;
};
const bRange1 = computed(() => (batteryA.value / 100) * 100);
const bRange2 = computed(() => ((batteryB.value - batteryA.value) / 100) * 100);
const bRange3 = computed(() => ((100 - batteryB.value) / 100) * 100);
const saveBatteryLevelRange = async () => {
  await Modify_Setting('battery_level_range', { low: batteryA.value, high: batteryB.value });
}
//#endregion

//#region 배터리 상태 범위 설정
const cellpowerA = ref(Get_Setting('cell_power_range').low);
const cellpowerB = ref(Get_Setting('cell_power_range').high);
const cellminValue = -200;
const cellmaxValue = 0;
const validateCellPowerInput = () => {
  if (cellpowerA.value < cellminValue) cellpowerA.value = cellminValue;
  if (cellpowerA.value > cellmaxValue) cellpowerA.value = cellmaxValue;
  if (cellpowerB.value < cellminValue) cellpowerB.value = cellminValue;
  if (cellpowerB.value > cellmaxValue) cellpowerB.value = cellmaxValue;
  if (cellpowerA.value > cellpowerB.value) cellpowerA.value = cellpowerB.value - 1;
};
const celltotalRange = cellmaxValue - cellminValue;
const cellNormalize = (value) => ((value - cellminValue) / celltotalRange) * 100;
const cRange1 = computed(() => cellNormalize(cellpowerA.value));
const cRange2 = computed(() => cellNormalize(cellpowerB.value) - cellNormalize(cellpowerA.value));
const cRange3 = computed(() => 100 - cellNormalize(cellpowerB.value));
const saveCellPowerRange = async () => {
  await Modify_Setting('cell_power_range', { low: cellpowerA.value, high: cellpowerB.value });
}
//#endregion

onMounted(() => {
  nextTick(() => {
    // previewImage.value = null;
  })
})
</script>

<style scoped>
.progress-bar {
  display: flex;
  width: calc(100% - 48px);
  height: 25px;
  border: 1px solid #ccc;
  margin: 24px 0;
}
.progress-bar div {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  gap: 5px;
  position: relative;

  h3 {
    position: absolute;
    bottom: -28px;
  }
  img {
    /* width: 30px; */
    height: auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
h3 {
  margin: 0;
  white-space: nowrap;       /* 줄바꿈 방지 */
  overflow: hidden;          /* 넘치는 내용 숨김 */
  text-overflow: ellipsis;   /* '...'으로 표시 */
}
</style>